import React, { Suspense } from 'react';
import { history } from './store/rootReducer';
import { ConnectedRouter } from 'connected-react-router';
import { LastLocationProvider } from 'react-router-last-location';
import { AuthenticationOidcProvider, AutoLogout, Spinner } from '@cp-shared-19/frontend-ui';
import { AxiosConfiguration } from 'auth/AxiosConfiguration';
import { logoutPath } from './components/navigation/paths';

export const Providers: React.FC = ({ children }) => {
    return (
        <Suspense fallback={<Spinner center />}>
            <AuthenticationOidcProvider userStore={window.sessionStorage}>
                <AutoLogout
                    oidc
                    idleTimeInMinutes={10}
                    redirectUri={`${window.location.origin}${logoutPath()}?logoutType=auto`}
                >
                    <AxiosConfiguration>
                        <ConnectedRouter history={history}>
                            <LastLocationProvider>{children}</LastLocationProvider>
                        </ConnectedRouter>
                    </AxiosConfiguration>
                </AutoLogout>
            </AuthenticationOidcProvider>
        </Suspense>
    );
};
